'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionsForValidCountries = exports.getCountryOptions = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getCountryName = require('./getCountryName');

var _getCountryName2 = _interopRequireDefault(_getCountryName);

var _sortOptions = require('./sortOptions');

var _sortOptions2 = _interopRequireDefault(_sortOptions);

var _CountryFlag = require('../components/CountryFlag');

var _CountryFlag2 = _interopRequireDefault(_CountryFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allCountryOptions = [];

var getCountriesByCode = function getCountriesByCode() {
  // Should return uppercase language codes and their translations
  return _I18n2.default.text('SharedI18nStrings.countryCodes');
};

var buildCountryOption = function buildCountryOption(countryCode) {
  var iso2 = countryCode.toLowerCase();
  return {
    text: (0, _getCountryName2.default)(iso2),
    value: iso2,
    avatar: _react2.default.createElement(_CountryFlag2.default, { countryCode: iso2 })
  };
};

var getCountryOptions = exports.getCountryOptions = function getCountryOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      optionsFilter = _ref.optionsFilter;

  if (!optionsFilter && allCountryOptions.length) {
    return allCountryOptions;
  } else if (optionsFilter && allCountryOptions.length) {
    return allCountryOptions.filter(optionsFilter);
  }

  allCountryOptions = Object.keys(getCountriesByCode()).map(function (code) {
    return buildCountryOption(code);
  }).sort(_sortOptions2.default);

  if (optionsFilter) {
    return allCountryOptions.filter(optionsFilter);
  }

  return allCountryOptions;
};

var getOptionsForValidCountries = exports.getOptionsForValidCountries = function getOptionsForValidCountries(_ref2) {
  var validCountries = _ref2.validCountries,
      optionsFilter = _ref2.optionsFilter;

  var options = [];
  var countriesByCode = getCountriesByCode();

  validCountries.forEach(function (countryCode) {
    if (countriesByCode[countryCode.toUpperCase()]) {
      options.push(buildCountryOption(countryCode));
    }
  });

  if (optionsFilter) {
    options = options.filter(optionsFilter);
  }

  return options.sort(_sortOptions2.default);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/internal/utils/getCountryOptions.js
// module id = 562
// module chunks = 3 4 5